import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ti-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.sass'],
})
export class ProgressBarComponent implements OnInit {
  @Input() value = 0;
  @Input() maxValue = 100;
  @Input() color: string;
  @Input() showValue = false;
  @Input() hideProgress = false;
  @Input() height = '1.5rem';
  @Input() labelColor = ''; //'#100040';
  @Input() hint = '';
  @Input() isIndeterminate = false;
  @Input() topLabel = false;
  @Input() showPercentSign = true;
  @Input() customLabel: string;
  @Input() bottomLabel = false;

  ngOnInit(): void {
    if (!this.color) {
      this.color = +this.value === 100 ? '#B8E986' : '#7AB8FF';
    }
  }

  getPercentage(): number {
    if (this.maxValue === 0) {
      return 0;
    }

    return +((100 * this.value) / this.maxValue).toFixed();
  }
}
